<template>
    <a
        id="locateMeLink"
        class="locate-me-link"
        role="button"
        tabindex="0"
        @click="locateMeClick"
        @keydown.enter="locateMeClick"
        @keydown.space="locateMeClick"
    >
        <img
            id="markerIcon"
            class="locate-me-icon"
            :src="markerIcon"
            :alt="locateMeIcon"
            aria-hidden="true"
        >
        {{ $t("App.LocateMeLink.LinkText") }}
    </a>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"
    import MarkerUtils from "../helpers/markerUtils"
    import { store } from '@/store/store'

    @Component
    export default class LocateMeLink extends Vue {
        MarkerUtils = new MarkerUtils(store.getters.contentServiceUrl, store.getters.contentServiceTimeStamp)

        get markerIcon(): string {
            return this.MarkerUtils.createLocateMarker()
        }

        get locateMeIcon(): string | undefined {
            return this.$t("App.LocateMeLink.AltText")
        }

        locateMeClick(): void {
            store.dispatch("setLocateMeClick")
            // Kun paikannetaan, siirret��n focus osoitekentt��n ja lis�t��n sille aria-liva-attribuutti,
            // jotta osoitteen p�ivittyminen havaitaan my�s ruudunlukijalla
            const addressField = document.getElementById("customSearch") as HTMLTextAreaElement
            addressField.focus()
            addressField.setAttribute("aria-live", "assertive")
            addressField.setAttribute("spellcheck", "false")

            setTimeout(() => {
                addressField.removeAttribute("aria-live")
            }, 5000)
        }
    }
</script>

<style scoped>
    a.locate-me-link {
        color: var(--Traficom-main-color);
        background-image: none;
        display: block;
        font-weight: 400;
        margin-top: 0.75rem;
        margin-bottom: 1rem;
    }

        a.locate-me-link:hover {
            color: var(--Traficom-main-color);
            font-weight: 600;
            cursor: pointer;
        }

    .locate-me-icon {
        width: 1.5625rem;
        height: 1.5625rem;
    }
</style>
